// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Orientation } from './orientation';


export class ImageOrientation {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):ImageOrientation {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

x():Orientation {
  return this.bb!.readUint8(this.bb_pos);
}

y():Orientation {
  return this.bb!.readUint8(this.bb_pos + 1);
}

z():Orientation {
  return this.bb!.readUint8(this.bb_pos + 2);
}

static sizeOf():number {
  return 3;
}

static createImageOrientation(builder:flatbuffers.Builder, x: Orientation, y: Orientation, z: Orientation):flatbuffers.Offset {
  builder.prep(1, 3);
  builder.writeInt8(z);
  builder.writeInt8(y);
  builder.writeInt8(x);
  return builder.offset();
}

}
